import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'karting-timing-controls-visible';

interface UseControlsVisibleResult {
  areControlsVisible: boolean;
  toggleControls: () => void;
}

function readFromStorage(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Shown by default — an admin who has never touched the toggle should still
    // find Start where they expect it.
    if (raw === null) return true;
    return raw === 'true';
  } catch (err) {
    console.error('Error loading control visibility from localStorage:', err);
    return true;
  }
}

/** Whether the Start/Stop bar is shown, remembered across reloads. */
export const useControlsVisible = (): UseControlsVisibleResult => {
  const [areControlsVisible, setAreControlsVisible] = useState<boolean>(
    () => readFromStorage(),
  );

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(areControlsVisible));
    } catch (err) {
      console.error('Error saving control visibility to localStorage:', err);
    }
  }, [areControlsVisible]);

  const toggleControls = useCallback(() => {
    setAreControlsVisible((prev) => !prev);
  }, []);

  return { areControlsVisible, toggleControls };
};
